import React from 'react';

const FIELD_BASE = [
    'w-full bg-surface border border-border rounded-md text-content text-sm placeholder:text-content-muted',
    'outline-none transition-colors',
    'focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20',
    'disabled:opacity-50 disabled:cursor-not-allowed',
].join(' ');

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className = '', ...props }, ref) => (
        <input ref={ref} className={[FIELD_BASE, 'px-2.5 py-2', className].join(' ')} {...props} />
    )
);
Input.displayName = 'Input';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
    ({ className = '', ...props }, ref) => (
        <textarea ref={ref} className={[FIELD_BASE, 'px-2.5 py-2 resize-y min-h-[80px]', className].join(' ')} {...props} />
    )
);
Textarea.displayName = 'Textarea';
